class TrustIndicatorsSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    const options = JSON.parse(this.dataset.swiperOptions || '{}');
    
    this.slider = new Swiper(this, {
      slidesPerView: options.slidesPerView || 1,
      spaceBetween: window.innerWidth >= 768 ? options.spaceBetweenDesktop : options.spaceBetweenMobile,
      navigation: options.navigation,
      breakpoints: {
        768: {
          slidesPerView: options.slidesPerView || 1,
          spaceBetween: options.spaceBetweenDesktop
        },
        990: {
          slidesPerView: options.slidesPerView + 1
        },
        1100: {
          slidesPerView: options.slidesPerView + 2
        }
      }
    });
  }
}

customElements.define('trust-indicators-slider', TrustIndicatorsSlider);